var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative w-full"
  }, [_c('button', {
    staticClass: "inline-flex w-full justify-between rounded-md border border-gray-300 bg-gray-50 px-4 py-2 h-custom-dropdown text-sm text-gray-500 hover:bg-gray-50 focus:outline-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', {
    staticClass: "flex flex-wrap gap-1 relative"
  }, [_vm.selectedOptions.length === 0 ? _c('span', {
    staticClass: "text-gray-500 font-medium mt-0.5"
  }, [_vm._v(_vm._s(_vm.defaultText))]) : _vm._e(), _vm._l(_vm.selectedOptions, function (item) {
    return _c('span', {
      key: item.value,
      staticClass: "bg-blue-100 text-blue-800 px-2 text-xs py-1 rounded-lg flex items-center gap-1"
    }, [_vm._v(" " + _vm._s(item.text) + " "), _c('button', {
      staticClass: "font-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeOption(item.value);
        }
      }
    }, [_vm._v("×")])]);
  })], 2), _c('svg', {
    staticClass: "ml-2 -mr-1 h-5 w-5 absolute right-4 top-3",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M19 9l-7 7-7-7"
    }
  })])]), _vm.isOpen ? _c('div', {
    staticClass: "absolute right-0 z-10 mt-2 w-full rounded-md bg-white border shadow max-h-60 overflow-auto"
  }, [_c('div', {
    staticClass: "p-2"
  }, _vm._l(_vm.options, function (option) {
    return _c('label', {
      key: option.value,
      staticClass: "flex items-center p-2 cursor-pointer hover:bg-gray-100"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedValues,
        expression: "selectedValues"
      }],
      staticClass: "form-checkbox h-4 w-4 rounded-sm text-blue-600",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": option.value,
        "checked": Array.isArray(_vm.selectedValues) ? _vm._i(_vm.selectedValues, option.value) > -1 : _vm.selectedValues
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.selectedValues,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = option.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedValues = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.selectedValues = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.selectedValues = $$c;
          }
        }
      }
    }), _c('span', {
      staticClass: "ml-2 text-gray-700"
    }, [_vm._v(_vm._s(option.text))])]);
  }), 0)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }